/**
 * Tasks MV2 QueryClient singleton.
 */
import { makeMv2QueryClient } from "@/features/_mv2/makeQueryClient";
import { setupMv2CachePersist } from "@/features/_mv2/mv2CachePersist";
import { TASK_ASSIGNEES_QUERY_KEY, fetchTaskAssigneesFromApi } from "./tasksQueryApi";

export const tasksQueryClient = makeMv2QueryClient();
setupMv2CachePersist(tasksQueryClient, "tasks");

export function prefetchTasks() {
  return tasksQueryClient.prefetchQuery({
    queryKey: [TASK_ASSIGNEES_QUERY_KEY],
    queryFn: ({ signal }) => fetchTaskAssigneesFromApi(signal),
  });
}
